<template>
  <div>
    <detail :prop="i18n.lbl_destination_asset()" :value="destinationAsset"/>
    <!-- <detail :prop="`${tx.destinationAsset} ${i18n.lbl_wallet()}`" :value="walletId" :copiable="true"/> -->
    <detail :prop="i18n.lbl_wallet()" v-if="wallet" :value="wallet" :copiable="true"/>
    <detail :prop="i18n.lbl_hash()" v-if="hash" :value="hash" :copiable="true"/>
    <detail :prop="i18n.lbl_internal_hash()" v-if="orderId && internalHash" :value="internalHash" :copiable="true"/>
    <detail :prop="i18n.lbl_order_id()" v-if="orderId" :value="orderId" :copiable="true"/>
    <detail :prop="i18n.lbl_order_amount()" v-if="orderAmount" :value="orderAmount"/>
    <detail :prop="i18n.lbl_order_network()" v-if="orderNetwork" :value="orderNetwork"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(tx.amount)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_fixed_fee()" :value="`${i18n.c(tx.fixedFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_percent_fee()" :value="`${i18n.c(tx.percentFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_destination_amount()" :value="`${i18n.c(tx.destinationAmount)} ${formatToken}`"/>
    <!-- <detail v-if="tx.rejectReason.length > 0" :prop="i18n.lbl_reject_reason()" :value="tx.rejectReason"/> -->
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <CheckSignList :id="internalId" :isHistory="true"/>
    <WithdrawalDelay :tx="localList" v-if="showDelay" @close="closeDelay" @refetchList="$emit('refetchList')"/>
    <Aml v-if="amlValues && aviliableAml" :score="riskScore" :values="amlValues"/>
  </div>
</template>

<script>
/* eslint-disable */
import Aml from './Aml.vue'
import DetailsMixin from './details.mixin'
import WithdrawalDelay from './WithdrawalDelay.vue'
import {withdrawUSDTService} from '@api/withdraw_usdt.service'
import {ErrorHandler} from '@js/errors/error_handler'
import {AML, isCryptoAsset, formatTokenDisplay} from '@utils/consts'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import CheckSignList from '../../../widrawalRequest/CheckSignList.vue'

export default {
  name: 'withdraw-details',
  mixins: [DetailsMixin, CurrencyRound],
  components: {
    Aml,
    WithdrawalDelay,
    CheckSignList
  },
  data() {
    return {
      showDelay: false,
      pollIntervalMs: 3000,
      isPollingInFlight: false
    }
  },
  computed: {
    formatToken () {
      return formatTokenDisplay(this.tx.asset)
    },
    destinationAsset () {
      return formatTokenDisplay(this.tx.destinationAsset)
    },
    wallet () {
      if (this.tx._record.external_details) {
        if (this.tx._record.external_details.address && this.tx._record.external_details.address !== '') {
          return this.tx._record.external_details.address
        }
        return false
      }
      return false
    },
    hash () {
      if (this.tx._record.reviewer_details && this.tx._record.reviewer_details.hash) {
        return this.tx._record.reviewer_details.hash
      }
      return false
    },
    internalId () {
      if (this.tx._record.external_details && this.tx._record.external_details.internalId) {
        return this.tx._record.external_details.internalId
      }
      return false
    },
    internalHash () {
      if (this.tx._record.external_details && this.tx._record.external_details.transaction_id) {
        return this.tx._record.external_details.transaction_id
      }
      return false
    },
    orderId () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_id) {
        return this.roundCurrency3(this.tx._record.external_details.order_id)
      }
      return false
    },
    orderNetwork () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_network) {
        return this.tx._record.external_details.order_network
      }
      return false
    },
    orderAmount () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_amount) {
        return `${this.roundCurrency3(this.tx._record.external_details.order_amount)} ${this.tx._record.external_details.order_currency
        ? this.tx._record.external_details.order_currency : ''}`
      }
      return false
    },
    aviliableAml () {
      if (isCryptoAsset(this.tx.destinationAsset)) {
        return true
      }
      return false
    },
    totalAmount () {
      return Number(this.withdraw.amount) + Number(Number(this.withdraw.fixedFee) + Number(this.withdraw.percentFee))
    },
    walletId () {
      return this.tx._record.external_details.withdrawalType === 'xpay' ? this.tx._record.external_details.displayName : this.tx.counterparty
    },
    riskScore () {
      const withDelay = this.tx.delay && this.tx.delay !== null && this.tx.delay.reviewer_details && this.tx.delay.reviewer_details.aml ? this.tx.delay.reviewer_details.aml : false
      const noDelay = this.tx._record.reviewer_details && this.tx._record.reviewer_details !== null && this.tx._record.reviewer_details.aml ? this.tx._record.reviewer_details.aml : false
      if (withDelay || noDelay) {
        const aml = withDelay !== false ? JSON.parse(withDelay) : noDelay
        const score = Number(aml[0])
        return isNaN(score) ? null : (score * 100).toFixed(1)
      }
      return null
    },
    amlValues () {
      const withDelay = this.tx.delay && this.tx.delay !== null && this.tx.delay.reviewer_details && this.tx.delay.reviewer_details.aml ? this.tx.delay.reviewer_details.aml : false
      const noDelay = this.tx._record.reviewer_details && this.tx._record.reviewer_details !== null && this.tx._record.reviewer_details.aml ? this.tx._record.reviewer_details.aml : false
      if (withDelay || noDelay) {
        // eslint-disable-next-line
        let arr = Object.values(withDelay !== false ? JSON.parse(withDelay) : noDelay)
        if (isNaN(Number(arr[0]))) return null
        let obj = AML.reduce((acc, key, index) => {
          acc[key] = arr[index]
          return acc
        }, {})
        let {'Risk score': removed, ...others} = obj
        return others
      }
      return null
    },
    localList: {
      get () {
        return this.tx
      },
      set (val) {
        this.tx.delay = val
      }
    }
  },
  mounted () {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    this.startToggleInterval()
  },
  methods: {
    closeDelay () {
      this.showDelay = false
    },
    hasInternalId () {
      return !!this.internalId
    },
    async watchDelaySafe () {
      if (!this.hasInternalId()) return
      if (document.hidden) return
      if (this.isPollingInFlight) return

      this.isPollingInFlight = true
      try {
        await this.watchDelay()
      } finally {
        this.isPollingInFlight = false
      }
    },
    async watchDelay () {
      try {
        const { data } = await withdrawUSDTService.getWithdrawalUSDTRequestInfo({
          internal_id: this.internalId
        })
        this.localList = data
        if (this.localList.delay) {
          this.showDelay = true
          this.stopToggleInterval()
          return
        }
        this.showDelay = false
      } catch (error) {
        ErrorHandler.processUnexpected(error)
      }
    },
    startToggleInterval () {
      if (!this.hasInternalId()) return
      if (document.hidden) return
      this.watchDelaySafe()
      if (this.intervalId) return
      this.intervalId = setInterval(() => {
        this.watchDelaySafe()
      }, this.pollIntervalMs)
    },
    onVisibilityChange () {
      if (document.hidden) {
        this.stopToggleInterval()
        return
      }
      this.startToggleInterval()
    },
    stopToggleInterval () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.stopToggleInterval()
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.Withdraw.vue